import React, { useState } from "react";
import {
  Card,
  Avatar,
  Text,
  Group,
  Button,
  Grid,
  ActionIcon,
  Stack,
  Loader,
  Center,
  Divider,
} from "@mantine/core";
import { useGetClients } from "api/client/useGetClients";
import {
  IconBriefcase,
  IconEdit,
  IconMail,
  IconPhone,
  IconTrash,
} from "@tabler/icons-react";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { fetchClientOverview } from "api/client/getClientProfile";
import UpdateClientModal from "./updateClient";
import { Client } from "api/client/updateClient";

interface ClientListingProps {
  onViewProfile?: (clientId: string, name: string) => void;
}

export function ClientListing({ onViewProfile }: ClientListingProps) {
  const [opened, setOpened] = useState(false);
  const [selectedClient, setSelectedClient] = useState<Client | null>(null);
  const { data: clients, isLoading, isError, error } = useGetClients();
  console.log(clients, "clientsss===>");
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <Center style={{ height: 200 }}>
        <Loader />
      </Center>
    );
  }
  if (isError) {
    return <Text color="red">{error.message}</Text>;
  }

  const handleViewProfile = async (clientId: string) => {
    try {
      await queryClient.prefetchQuery(["clientOverview", clientId], () =>
        fetchClientOverview(clientId)
      );
    } catch (err) {
      console.error("Overview prefetch failed", err);
    } finally {
      navigate(`/client-profile/${clientId}`);
    }
  };
  const openEditModal = (client: Client) => {
    setSelectedClient(client);
    setOpened(true);
  };
  return (
    <Grid>
      {clients.map((client) => (
        <Grid.Col xs={12} md={6}>
          <Card
            key={client._id}
            shadow="sm"
            p="lg"
            radius="md"
            withBorder
            // style={{ width: 700 }}
          >
            <Group align="flex-start" noWrap>
              <Stack align="center" spacing="xs">
                <Avatar size={100} radius="xl">
                  {client.name.charAt(0)}
                </Avatar>
                <Text size="md" weight={700}>
                  TECH
                </Text>
                <Group spacing={8}>
                  <ActionIcon
                    color="blue"
                    variant="light"
                    onClick={() => openEditModal(client)}
                  >
                    <IconEdit size={16} />
                  </ActionIcon>
                  <ActionIcon color="red" variant="light" disabled>
                    <IconTrash size={16} />
                  </ActionIcon>
                </Group>
              </Stack>

              <Divider orientation="vertical" />

              <Stack spacing="sm" style={{ width: "100%" }}>
                <div>
                  <Text size="lg" weight={600}>
                    {client.name}
                  </Text>
                  <Group spacing="xs">
                    <IconPhone size={16} />
                    <Text size="sm" color="dimmed">
                      {client.phone}
                    </Text>
                  </Group>
                  <Group spacing="xs">
                    <IconMail size={16} />
                    <Text size="sm" color="dimmed">
                      {client.email}
                    </Text>
                  </Group>
                </div>

                <Text size="sm" lineClamp={3}>
                  {client.description}
                </Text>

                <Group mt="md">
                  <Button
                    leftIcon={<IconBriefcase size={16} />}
                    onClick={() => handleViewProfile(client._id)}
                  >
                    Profile
                  </Button>
                </Group>
              </Stack>
            </Group>
          </Card>
        </Grid.Col>
      ))}
      <UpdateClientModal
        opened={opened}
        client={selectedClient}
        onClose={() => setOpened(false)}
      />
    </Grid>
  );
}
